import { useQuery } from '@tanstack/react-query';
import type { ProcessFlowProcess, ProcessFlowQuery } from '@/@types/ProcessFlow';
import type { RequestState } from '../../@types/RequestState';
import { getGql } from '../../fetch';
import useBranch from '../branch/useBranch';
import { GET_PROCESSES } from './queries/processes';
import { PF_QUERY_KEYS } from './queryKeys';

const useProcesses = (disabled = false): [ProcessFlowProcess[] | undefined, RequestState] => {
  const [branch, requestBranch] = useBranch();

  const { data, isLoading, isSuccess, isError } = useQuery<ProcessFlowQuery>({
    queryKey: [PF_QUERY_KEYS.processes, branch?.id],
    queryFn: async ({ signal }) =>
      getGql<ProcessFlowQuery>(
        `${process.env.NEXT_PUBLIC_PROCESS_FLOW_URI}/graphql?groupId=${branch?.id}`,
        GET_PROCESSES,
        { groupId: branch?.id },
        signal,
      ),
    enabled: !!branch?.id && !disabled,
    placeholderData: (prev) => prev,
  });

  return [
    data?.processes || undefined,
    {
      isSuccess: isSuccess && requestBranch.isSuccess,
      isError: isError || requestBranch.isError,
      isLoading: isLoading || requestBranch.isLoading,
    },
  ];
};

export default useProcesses;
